/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from '@sentry/react';
import { AuthBootstrap } from './components/Auth/AuthBootstrap';

if (import.meta.env.VITE_ENV === 'staging') {
  Sentry.init({
    dsn: 'https://f0b54462e938186e7e1ca16c6fd4d38e@o4510306279620608.ingest.us.sentry.io/4510306284929024',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/app.spotlock.co\/api/],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Enable logs to be sent to Sentry
    enableLogs: true,
  });
}
//@ts-ignore
const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID!;
//@ts-ignore
window.isProd = import.meta.env.VITE_ENV === 'prod';
//@ts-ignore
window.isStaging = import.meta.env.VITE_ENV === 'staging';

//@ts-ignore
window.functionsUrl = import.meta.env.VITE_FUNCTIONS_URL || 'https://us-central1-spotlock-b8afb.cloudfunctions.net/';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <AuthBootstrap>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthBootstrap>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
